export default "__VITE_ASSET__Bdxu5f0D__"